import { useDealItemPicker } from './DealItemPicker';
import { useModal } from 'components/modal/ModalStack';
import { useState } from 'libs/react';
import { DealItemPickerOptionAlert } from './DealItemPickerOptionAlert';
import { Money } from 'components/Money';
import { Table } from 'components/table/Table';
import { Text } from 'components/Text';
import { Fragment } from 'libs/react';
import { findPriceListPrice } from 'helpers/priceList';
import { React } from 'libs/react';
import { SaleItemIcon } from 'modules/catalog/saleItem/components/SaleItemIcon';
import { getRelations } from 'helpers/Deal';
import { calculatePriceCurrency } from 'helpers/Pricing';
import { FormInput } from 'components/form/FormInput';
import { FormSelect } from 'components/form/FormSelect';
import { FormIconCheckBox } from 'components/form/FormIconCheckBox';
import { ButtonGroup } from 'components/ButtonGroup';
import { Icon } from 'components/Icon';
import { SaleItemViewer } from 'components/saleItem/SaleItemViewer';
import './DealItemPickerOptionTable.scss';
/**
 * @component DealItemPickerOptionTable
 * @since 1.0.0
 */
export function DealItemPickerOptionTable(props) {
    const { display, values, optionReplacement } = props;
    const [types, setTypes] = useState({});
    const [quantityAlert, setQuantityAlert] = useState(false);
    const [currentSelections, setCurrentSelections] = useState([]);
    const modal = useModal();
    const { item, variant, options, appendOption, removeOption, dealOptions, setDealOptions, deal, quantityType, quantity, priceLists, alternativeTo, updateRelatedOptionsQuantity, hideSku } = useDealItemPicker();
    // Use the values prop for display, but dealOptions for state management
    const tableValues = values || [];
    /**
     * @function isChecked
     * @since 1.0.0
     * @hidden
     */
    function isChecked(item) {
        const option = options.find((entry) => entry.item.id == item.item.id);
        if (option == null) {
            return false;
        }
        return true;
    }
    /**
     * @function isDisabled
     * @since 1.0.0
     * @hidden
     */
    function isDisabled(item) {
        if (item === null || item === void 0 ? void 0 : item.locked) {
            return true;
        }
        return false;
    }
    /**
     * @function isProposed
     * @since 1.0.0
     * @hidden
     */
    function isProposed(item) {
        var _a;
        const option = options.find((entry) => entry.item.id == item.item.id);
        if (option == null) {
            return false;
        }
        return (_a = option.proposed) !== null && _a !== void 0 ? _a : false;
    }
    /**
     * @function getPrice
     * @since 1.0.0
     * @hidden
     */
    function getPrice(item) {
        const option = options.find((entry) => entry.item.id == item.item.id);
        if (option == null) {
            return item.price;
        }
        return option.price;
    }
    /**
     * @function getQuantity
     * @since 1.0.0
     * @hidden
     */
    function getQuantity(item) {
        const option = options.find((entry) => entry.item.id == item.item.id);
        if (!option || !option.quantity) {
            return 0;
        }
        return option.quantity;
    }
    /**
     * @function onQuantityChange
     * @since 1.0.0
     * @hidden
     */
    function onQuantityChange(item, qty) {
        //if (parseInt(qty) !== getQuantity(item)) {
        setQuantityAlert(true); // TODO : We no longer have this state for now
        //}
    }
    /**
     * @function onQuantityBlur
     * @since 1.0.0
     * @hidden
     **/
    function onQuantityBlur(item, qty) {
        const isSelected = options.find((option) => option.item.id === item.item.id);
        const proposed = isProposed(item);
        /**
         * @function execute
         * @hidden
         * @since 1.0.0
         */
        function execute(makeChange) {
            /*if (isSelected) {
              removeOption(item.item);
              appendOption(
                item.item,
                item.price ?? 0,
                false,
                proposed,
                item.included,
                makeChange ? parseInt(qty) : quantity
              );
            } else {
              appendOption(
                item.item,
                item.price ?? 0,
                false,
                proposed,
                item.included,
                makeChange ? parseInt(qty) : quantity
              );
            }*/
            // Update related options quantity
            updateRelatedOptionsQuantity(item, parseInt(qty));
        }
        if (quantityAlert) {
            setQuantityAlert(false);
            /*modal.present({
              style: 'dialog',
              title: t('Update quantity'),
              picto: 'edit',
              modal: (
                <Confirm
                  title={`${t(
                    'You are about to change the quantity that is different from the product quantity. Are you sure you want to continue?'
                  )}`}
                  infos={t(
                    'Selecting "Yes" will update the quantity of the option. Selecting "No" will cancel the update.'
                  )}
                  acceptText={t('Yes')}
                  refuseText={t('No')}
                  onAccept={() => {
                    execute(true);
                  }}
                  onRefuse={() => {
                    execute(false);
                  }}
                />
              )
            });*/
            execute(true);
        }
    }
    /**
     * @function getPriceList
     * @since 1.0.0
     * @hidden
     */
    function getPriceList(item) {
        const option = options.find((entry) => entry.item.id == item.item.id);
        if (option == null) {
            return null;
        }
        return option.priceList;
    }
    /**
     * @function onPriceListChange
     * @since 1.0.0
     * @hidden
     */
    function onPriceListChange(item, value) {
        var _a, _b;
        // FormSelect also fires onChange when its value prop changes; ignore
        // those echoes so they don't re-append the option as selected
        if ((value || null) == ((_b = (_a = getPriceList(item)) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null)) {
            return;
        }
        let newPrice = item.price;
        // Change deal option price with price from price list
        const priceList = priceLists.find((priceList) => priceList.id == value);
        const priceListPrice = findPriceListPrice(priceList, item.item.id);
        const index = dealOptions.findIndex((dealOption) => dealOption.item.id == item.item.id);
        if (index == -1) {
            return;
        }
        const tempArray = [...dealOptions];
        newPrice = priceListPrice !== null && priceListPrice !== void 0 ? priceListPrice : newPrice;
        tempArray[index] = Object.assign(Object.assign({}, tempArray[index]), { priceListPrice: newPrice });
        setDealOptions(tempArray);
        if (alternativeTo) {
            onAlternativeSelect(item, true, value);
        }
        else {
            appendOption(item.item, newPrice !== null && newPrice !== void 0 ? newPrice : 0, false, isProposed(item), item.included, getQuantity(item) || quantity, priceList);
        }
    }
    /**
     * @function editConfiguration
     * @since 1.0.0
     * @hidden
     */
    function editConfiguration(i, relations, fromParent, visited = new Set()) {
        // A reciprocal incompatibility (A excludes B and B excludes A) must not
        // reopen this dialog. The same guard stops a conditional cycle.
        if (i === null || i === void 0 ? void 0 : i.id) {
            if (visited.has(i.id)) {
                return;
            }
            visited.add(i.id);
        }
        /**
         * @function onAccept
         * @since 1.0.0
         * @hidden
         */
        function onAccept() {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (!fromParent) {
                const optionQuantity = (_b = (_a = dealOptions.find((dealOpt) => dealOpt.item.id == i.id)) === null || _a === void 0 ? void 0 : _a.quantity) !== null && _b !== void 0 ? _b : 0;
                appendOption(i, (_d = (_c = dealOptions.find((dealOpt) => dealOpt.item.id == i.id)) === null || _c === void 0 ? void 0 : _c.price) !== null && _d !== void 0 ? _d : 0, false, types[i.id] == 'proposed', false, optionQuantity > 0 ? optionQuantity : quantity);
            }
            if (optionReplacement == 'code') {
                dealOptions.forEach((dealOpt) => {
                    if (isNaN(Number(dealOpt.item.sku.slice(0, 2))) &&
                        dealOpt.item.sku.startsWith(i.sku.slice(0, 2)) &&
                        dealOpt.item.id != i.id &&
                        isChecked(dealOpt)) {
                        removeOption(dealOpt.item);
                    }
                });
            }
            if (relations) {
                // First, handle incompatible relations to update their state
                for (const relation of relations) {
                    if (relation.type === 'INCOMPATIBLE') {
                        removeOption(relation.relatedSaleItem);
                        setDealOptions((prevDealOptions) => prevDealOptions.map((opt) => opt.item.id === relation.relatedSaleItem.id
                            ? Object.assign(Object.assign({}, opt), { included: false, locked: false }) : opt));
                    }
                }
                // Then handle conditional relations that belong to this quote item.
                for (const relation of relations) {
                    if (relation.type === 'CONDITIONAL') {
                        const linkedToQuote = dealOptions.some((dealOpt) => dealOpt.item.id === relation.relatedSaleItem.id);
                        if (!linkedToQuote) {
                            continue;
                        }
                        const currentQuantity = (_f = (_e = options.find((dealOpt) => dealOpt.item.id == relation.relatedSaleItem.id)) === null || _e === void 0 ? void 0 : _e.quantity) !== null && _f !== void 0 ? _f : 0;
                        appendOption(relation.relatedSaleItem, (_g = relation.relatedSaleItem.price) !== null && _g !== void 0 ? _g : 0, false, types[i.id] == 'proposed', false, currentQuantity + quantity * relation.quantity);
                        // Update dealOptions state for conditional relations
                        setDealOptions((prevDealOptions) => {
                            const existingOption = prevDealOptions.find((dealOpt) => dealOpt.item.id == relation.relatedSaleItem.id);
                            if (!existingOption) {
                                const newOption = {
                                    item: relation.relatedSaleItem,
                                    price: relation.relatedSaleItem.price,
                                    quantity: relation.quantity,
                                    priceListPrice: relation.relatedSaleItem.price,
                                    included: false,
                                    locked: false,
                                    proposed: false,
                                    recommended: false
                                };
                                return [...prevDealOptions, newOption];
                            }
                            return prevDealOptions;
                        });
                        if (optionReplacement == 'code') {
                            dealOptions.forEach((dealOpt) => {
                                if (isNaN(Number(dealOpt.item.sku.slice(0, 2))) &&
                                    dealOpt.item.sku.startsWith(relation.relatedSaleItem.sku.slice(0, 2)) &&
                                    dealOpt.item.id != relation.relatedSaleItem.id &&
                                    isChecked(dealOpt)) {
                                    removeOption(dealOpt.item);
                                }
                            });
                        }
                        // Follow only options this choice adds. Incompatible targets are
                        // removed above; walking them reopens the option just accepted.
                        const relatedId = (_h = relation.relatedSaleItem) === null || _h === void 0 ? void 0 : _h.id;
                        if (!relatedId || visited.has(relatedId)) {
                            continue;
                        }
                        const subRelations = getRelations(item, variant, relation.relatedSaleItem, options, true).filter((subRelation) => {
                            var _a;
                            const targetId = (_a = subRelation.relatedSaleItem) === null || _a === void 0 ? void 0 : _a.id;
                            if (targetId && visited.has(targetId)) {
                                return false;
                            }
                            if (subRelation.type !== 'CONDITIONAL') {
                                return true;
                            }
                            return dealOptions.some((dealOpt) => dealOpt.item.id === targetId);
                        });
                        if (subRelations.length) {
                            editConfiguration(relation.relatedSaleItem, subRelations, true, visited);
                        }
                    }
                }
            }
        }
        /**
         * @function onDiscard
         * @since 1.0.0
         * @hidden
         */
        function onDiscard() { }
        modal.present({
            style: 'dialog',
            title: t('Edit Configuration'),
            picto: 'check',
            modal: (React.createElement(DealItemPickerOptionAlert, { item: i, relations: relations, onAccept: onAccept, onDiscard: onDiscard }))
        });
    }
    /**
     * @function onCheckChange
     * @since 1.0.0
     * @hidden
     */
    function onCheckChange(option, dealOption, check, proposed) {
        var _a, _b, _c;
        if (check &&
            options.find((entry) => entry.item.id == option.id) &&
            !isProposed(dealOption)) {
            return;
        }
        if (check) {
            if ((values === null || values === void 0 ? void 0 : values.find((value) => value.item.id !== dealOption.item.id &&
                isNaN(Number(dealOption.item.sku.slice(0, 2))) &&
                value.item.sku.startsWith(dealOption.item.sku.slice(0, 2)) &&
                value.locked)) &&
                optionReplacement == 'code') {
                return;
            }
            // check if we are in a group with unique option restriction
            if (((_a = option.group) === null || _a === void 0 ? void 0 : _a.hasUniqueOptionRestriction) &&
                (proposed === null || proposed === false || proposed === undefined)) {
                dealOptions.forEach((dealOpt) => {
                    var _a, _b;
                    if (((_a = dealOpt.item.group) === null || _a === void 0 ? void 0 : _a.id) == ((_b = option.group) === null || _b === void 0 ? void 0 : _b.id) &&
                        dealOpt.item.id != option.id &&
                        isChecked(dealOpt)) {
                        removeOption(dealOpt.item);
                        setDealOptions((prevState) => prevState.map((opt) => opt.item.id === dealOpt.item.id
                            ? Object.assign(Object.assign({}, opt), { included: false, locked: false }) : opt));
                    }
                });
            }
            if (proposed === null || proposed === false || proposed === undefined) {
                // Get relations for the option
                const relations = getRelations(item, variant, option, options, true).filter((relation) => relation.type !== 'CONDITIONAL' ||
                    dealOptions.some((dealOpt) => { var _a; return dealOpt.item.id === ((_a = relation.relatedSaleItem) === null || _a === void 0 ? void 0 : _a.id); }));
                if (relations && relations.length) {
                    editConfiguration(option, relations);
                    return;
                }
            }
            appendOption(option, (_b = dealOption.price) !== null && _b !== void 0 ? _b : 0, false, proposed !== null && proposed !== void 0 ? proposed : false, dealOption.included, dealOption.quantity > 0 ? dealOption.quantity : quantity, undefined, alternativeTo);
            if (optionReplacement == 'code' &&
                (proposed == undefined || proposed == false)) {
                dealOptions.forEach((dealOpt) => {
                    if (isNaN(Number(dealOpt.item.sku.slice(0, 2))) &&
                        dealOpt.item.sku.startsWith(option.sku.slice(0, 2)) &&
                        dealOpt.item.id != option.id &&
                        isChecked(dealOpt)) {
                        removeOption(dealOpt.item);
                    }
                });
            }
        }
        else {
            // Check if we have a group with must have option selected
            if ((_c = option.group) === null || _c === void 0 ? void 0 : _c.mustHaveOptionSelected) {
                const optionsInGroup = dealOptions.filter((dealOpt) => { var _a, _b; return ((_a = dealOpt.item.group) === null || _a === void 0 ? void 0 : _a.id) == ((_b = option.group) === null || _b === void 0 ? void 0 : _b.id); });
                const optionsInGroupSelected = optionsInGroup.filter((dealOpt) => isChecked(dealOpt));
                // check if we have deal options in the group that are not the one we are removing
                if (optionsInGroupSelected.filter((dealOpt) => dealOpt.item.id != option.id).length === 0) {
                    return;
                }
            }
            if (dealOption.included) {
                setDealOptions((prevState) => {
                    const matchIndex = prevState.findIndex((val) => val.item.id === dealOption.item.id);
                    const tempArray = [...prevState];
                    tempArray[matchIndex] = Object.assign(Object.assign({}, tempArray[matchIndex]), { included: false });
                    return tempArray;
                });
            }
            removeOption(option);
        }
    }
    /**
     * @function onTypeChange
     * @since 1.0.0
     * @hidden
     */
    function onTypeChange(item, proposed) {
        var _a, _b, _c;
        const isSelected = options.find((option) => option.item.id === item.item.id);
        removeOption(item.item);
        if (proposed) {
            appendOption(item.item, (_b = (_a = isSelected === null || isSelected === void 0 ? void 0 : isSelected.price) !== null && _a !== void 0 ? _a : item.price) !== null && _b !== void 0 ? _b : 0, false, proposed, item.included, (_c = isSelected === null || isSelected === void 0 ? void 0 : isSelected.quantity) !== null && _c !== void 0 ? _c : quantity, isSelected === null || isSelected === void 0 ? void 0 : isSelected.priceList);
        }
    }
    /**
     * @function onAlternativeSelect
     * @since 1.0.0
     * @hidden
     */
    function onAlternativeSelect(value, check, priceListId) {
        var _a, _b, _c, _d;
        if (check) {
            const alternativeQuantity = (_b = (_a = options.find((option) => option.item.id === alternativeTo)) === null || _a === void 0 ? void 0 : _a.quantity) !== null && _b !== void 0 ? _b : quantity;
            if (priceListId) {
                const alternativePriceList = priceLists.find((priceList) => priceList.id == priceListId);
                if (alternativePriceList) {
                    value.price =
                        (_c = findPriceListPrice(alternativePriceList, value.item.id)) !== null && _c !== void 0 ? _c : value.price;
                }
            }
            appendOption(value.item, (_d = value.price) !== null && _d !== void 0 ? _d : 0, false, true, false, alternativeQuantity, undefined, alternativeTo);
            setCurrentSelections([...currentSelections, value.item.id]);
        }
        else {
            removeOption(value.item);
            setCurrentSelections(currentSelections.filter((id) => id !== value.item.id));
        }
    }
    /**
     * @function onShowSaleItemViewer
     * @since 1.0.0
     * @hidden
     */
    function onShowSaleItemViewer(item) {
        if (item) {
            modal.present({
                title: item === null || item === void 0 ? void 0 : item.sku,
                picto: '',
                className: 'deal-sale-item-selector-item-modal',
                modal: React.createElement(SaleItemViewer, { item: item })
            });
        }
    }
    const onColumnClick = (value) => {
        if (isDisabled(value)) {
            return;
        }
        onCheckChange(value.item, value, !isChecked(value));
    };
    const columns = [];
    columns.push({
        column: 'image',
        type: 'image',
        header: '',
        footer: '',
        render: (value) => {
            return (React.createElement(Fragment, null,
                React.createElement("div", { onClick: (e) => {
                        e.stopPropagation();
                        onShowSaleItemViewer(value.item);
                    } },
                    React.createElement(SaleItemIcon, { item: value.item }))));
        }
    });
    if (!hideSku) {
        columns.push({
            column: 'item.sku',
            header: t('SKU'),
            footer: t('SKU'),
            onClick: onColumnClick,
            render: (value) => {
                return (React.createElement(Fragment, null,
                    React.createElement(Text, { className: "table-row-value", value: value.item.sku })));
            }
        });
    }
    columns.push({
        column: 'item.title',
        header: t('Name'),
        footer: t('Name'),
        onClick: onColumnClick,
        render: (value) => {
            return (React.createElement(Fragment, null,
                React.createElement(Text, { className: "table-row-value", value: value.item.title })));
        }
    });
    if (!alternativeTo &&
        (quantityType === 'GRANULAR' || quantityType === 'ITEM_CONFIGURATION')) {
        columns.push({
            column: 'quantity',
            header: t('Quantity'),
            footer: t('Quantity'),
            render: (value) => {
                var _a, _b;
                return (React.createElement(Fragment, null,
                    React.createElement("div", { className: "table-row-status", onClick: (e) => {
                            e.stopPropagation();
                        } },
                        React.createElement(FormInput, { name: "quantity", type: "number", value: (_b = (_a = getQuantity(value)) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '1', onFocus: () => onCheckChange(value.item, value, true, isProposed(value)), onChange: (v) => {
                                onQuantityChange(value, v);
                            }, onBlur: (v) => {
                                onQuantityBlur(value, v);
                            }, size: "small", disabled: isDisabled(value) }))));
            }
        });
    }
    if (priceLists === null || priceLists === void 0 ? void 0 : priceLists.length) {
        columns.push({
            column: 'priceLists',
            header: t('Price Lists'),
            footer: t('Price Lists'),
            render: (value) => {
                var _a, _b;
                return (React.createElement(Fragment, null,
                    React.createElement(FormSelect, { name: "priceLists", placeholder: t('Standard'), value: (_b = (_a = getPriceList(value)) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null, onChange: (v) => {
                            onPriceListChange(value, v);
                        }, options: priceLists.map((priceList) => ({
                            value: priceList.id,
                            label: priceList.title
                        })), size: "small" })));
            }
        });
    }
    columns.push({
        column: 'list',
        header: t('Price'),
        footer: t('Price'),
        onClick: onColumnClick,
        render: (value) => {
            var _a;
            return (React.createElement("div", { className: "table-row-price-container" },
                React.createElement(Money, { value: calculatePriceCurrency((_a = getPrice(value)) !== null && _a !== void 0 ? _a : 0, deal === null || deal === void 0 ? void 0 : deal.currency), className: "table-row-money" })));
        }
    });
    if (!alternativeTo) {
        columns.push({
            column: 'type',
            header: t('Actions'),
            infos: t('Suggest or select'),
            footer: t('Actions'),
            align: 'center',
            render: (value) => {
                return !isDisabled(value) ? (React.createElement(Fragment, null,
                    React.createElement(ButtonGroup, null,
                        React.createElement(FormIconCheckBox, { checked: isProposed(value), checkedColor: "primary", disabled: isDisabled(value), checkedIcon: "fal heart-circle-check", uncheckedIcon: "fal heart", onChange: (check) => {
                                onTypeChange(value, check);
                            } }),
                        React.createElement(FormIconCheckBox, { checked: isChecked(value) && !isProposed(value), checkedColor: "secondary", disabled: isDisabled(value), checkedIcon: "fal check", uncheckedIcon: "fal plus", onChange: (check) => {
                                onCheckChange(value.item, value, check);
                            } })))) : (React.createElement(Fragment, null,
                    React.createElement(Icon, { className: "table-row-locked table-row-image", value: "hexagon-check" })));
            }
        });
    }
    else {
        columns.push({
            column: 'type',
            header: t('Action'),
            infos: t('Select'),
            footer: t('Action'),
            align: 'center',
            render: (value) => {
                return (React.createElement(Fragment, null,
                    React.createElement(FormIconCheckBox, { className: "table-row-image", checked: currentSelections.includes(value.item.id), checkedColor: "secondary", checkedIcon: "fal check", uncheckedIcon: "fal plus", onChange: (check) => {
                            onAlternativeSelect(value, check);
                        }, disabled: isChecked(value) && !currentSelections.includes(value.item.id) })));
            }
        });
    }
    const schema = {};
    columns.forEach((column, index) => {
        schema['c' + (index + 1)] = column;
    });
    return display == undefined || display == 'DEFAULT' || display == 'LIST' ? (React.createElement(Table, { className: "deal-item-picker-option-table", schema: schema, values: tableValues, sortable: ['c2', 'c3'], primaryColumn: "c2" })) : ((display == 'IMAGE' && (React.createElement("div", { className: "deal-item-picker-option-image-container" }, tableValues.map((value, index) => {
        var _a, _b, _c;
        const checked = isChecked(value);
        return (React.createElement("div", { className: `deal-item-picker-option-image ${checked && 'checked'}`, key: index },
            React.createElement("div", { className: "deal-item-picker-option-item-container" },
                React.createElement(SaleItemIcon, { item: value.item, className: "deal-item-picker-option-image-item-image-icon" }),
                React.createElement("div", null,
                    React.createElement(Text, { value: value.item.title, className: "deal-item-picker-option-image-item-title" }),
                    React.createElement(Money, { value: calculatePriceCurrency((_a = value.price) !== null && _a !== void 0 ? _a : 0, deal === null || deal === void 0 ? void 0 : deal.currency), className: "deal-item-picker-option-image-item-price" }))),
            React.createElement("div", { className: "deal-item-picker-option-image-item-form" },
                React.createElement("div", { className: "deal-item-picker-option-image-item-form-quantity" },
                    React.createElement(FormInput, { name: "quantity", type: "number", value: (_c = (_b = getQuantity(value)) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '1', onChange: (v) => {
                            onQuantityChange(value, v);
                        }, onFocus: () => onCheckChange(value.item, value, true, isProposed(value)), onBlur: (v) => {
                            onQuantityBlur(value, v);
                        }, size: "small" })),
                React.createElement("div", { className: "deal-item-picker-option-image-item-check" },
                    React.createElement(FormIconCheckBox, { checked: isProposed(value), checkedColor: "primary", disabled: isDisabled(value), checkedIcon: "fal heart-circle-check", uncheckedIcon: "fal heart", onChange: (check) => {
                            onTypeChange(value, check);
                        } }),
                    React.createElement(FormIconCheckBox, { checked: isChecked(value) && !isProposed(value), checkedColor: "secondary", disabled: isDisabled(value), checkedIcon: "fal check", uncheckedIcon: "fal plus", onChange: (check) => {
                            onCheckChange(value.item, value, check);
                        } })))));
    })))) || React.createElement(Fragment, null));
}
